import Link from "next/link";
import React from "react";
import Image from "next/image";
import { motion } from "framer-motion";
import { getFileUrl } from "@/shared";
import { useSearchParams } from "next/navigation";

interface MediaCardProps {
  item: any;
  className?: string;
}

const categoryColors = {
  모집: "var(--color-label-blue)",
  공지: "var(--color-label-red)",
  소식: "var(--color-label-gray)",
};

export const MediaCardBase: React.FC<MediaCardProps> = ({
  item,
  className = "",
}) => {
  const searchParams = useSearchParams();

  const categoryColor = item.common_category
    ? categoryColors[item.common_category.name as keyof typeof categoryColors]
    : "var(--color-label-gray)";

  return (
    <Link
      href={{
        pathname: `/app/media/${item.id}`,
        query: searchParams?.toString() || "",
      }}
      className={`block h-full  ${className}`}
    >
      <motion.div
        className="flex flex-col h-full bg-white rounded-4xl overflow-hidden border border-[#eee]"
        style={{ boxShadow: "2px 4px 21.7px rgba(99, 99, 99, 0.11)" }}
        // initial={{ opacity: 0, y: 20 }}
        // whileInView={{ opacity: 1, y: 0 }}
        // viewport={{ once: true, amount: 0.1 }}
        // transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
      >
        <Image
          src={
            item.cover?.file_url
              ? getFileUrl(item.cover?.file_url)
              : "/assets/images/default_image.svg"
          }
          alt="thumbnail"
          width={800}
          height={240}
          className={`w-full h-[180px] md:h-[240px] object-cover ${
            item.cover?.file_url ? "object-top md:object-top" : "object-center"
          }`}
        />
        <div className="py-6 px-6 md:py-6 md:px-8 flex flex-col justify-between">
          {/* 카테고리 라벨 */}
          {item.common_category && (
            <div
              className="text-white self-baseline md:text-base md:leading-6 pt-1.5 pb-1 px-3 rounded-full mb-3.5 text-sm leading-5 tracking-tight"
              style={{
                backgroundColor: categoryColor,
                fontFamily: '"pre-Medium", sans-serif',
              }}
            >
              {item.common_category.name}
            </div>
          )}
          {/* 제목 */}
          <h3 className="semibold-text-20 line-clamp-2 mb-1 md:min-h-18 text-black-200 text-md-18">
            {item.title}
          </h3>
          {/* 날짜 */}
          <p className="text-lightGray-10 regular-text-16 text-md-14">
            {new Date(item.created_at).toLocaleDateString("ko")}
          </p>
        </div>
      </motion.div>
    </Link>
  );
};
